import { FolderShare } from "./useQueryFolderShares";

export function getTeamIdsFromShares(shares: FolderShare[]) {
  return shares
    .filter((share) => share.shareType === "team")
    .map((share) => share.shareId);
}
